import { fromJS, merge } from 'immutable';
import { FluxStandardAction } from '__utils/type';
import * as Actions from 'constants/actions'

export interface bankDetailsState {
 
    ifscContent: any;
    fetchSearchIfscError: any;
    

}
const rawState: bankDetailsState = {
  
    ifscContent: "",
    fetchSearchIfscError: ""
};

const intialState = fromJS(rawState);

export default function bankDetailsReducer (
    state = intialState,
    action: FluxStandardAction
) {
    switch (action.type)
    {
       
        case Actions.FETCH_GET_CHECK_IFSC_SUCCESS:
            return merge(state, fromJS({ ifscContent: action.payload.data }));
        case Actions.FETCH_GET_CHECK_IFSC_ERROR:
            return merge(state, fromJS({ fetchSearchIfscError: action.payload.data }));
        default:
            return state;
    }
}
